import { callApi } from "../../api";
import { CitiesApi } from "../cities/api";
import { CustomersApi } from "../customers/api";
import { CustomersSettingsApi } from "../customersSettings/api";
const methods = {
  current: 'users.actions.current'
};

const viewCurrentUser = searchQuery => callApi(methods.current, searchQuery);

export const UsersApi = {
  viewCurrentUser,
  viewUser: CustomersApi.view,
  viewSettings: CustomersSettingsApi.view,
  updateUser: CustomersApi.update,
  updateSettings: CustomersSettingsApi.update,
  viewUserCity: CitiesApi.defaultCity
};